import { CopyOutlined } from '@ant-design/icons'
import { Box, Flex, Text } from '@weareberyl/design-system'
import { Tooltip } from 'antd'
import { Component } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'

type CopyProps = {
  id: string
  text: string
  handler?: (text: string) => void
  showText: boolean
  nowrap?: boolean
}

type CopyState = {
  copied: boolean
}

export default class Copy extends Component<CopyProps, CopyState> {
  static defaultProps = {
    showText: true,
  }

  state = {
    copied: false,
  }

  render() {
    const { text, handler, id, showText, nowrap } = this.props
    const nowrapStyle = {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    }

    const style = nowrap ? nowrapStyle : {}

    if (text) {
      return (
        <Flex>
          <CopyToClipboard
            text={text}
            onCopy={() => {
              this.setState({ copied: true })
              if (handler) {
                handler(text)
              }
              setTimeout(() => this.setState({ copied: false }), 1000)
            }}
          >
            <Tooltip open={this.state.copied} title="Copied!">
              <Box mr={1} mt={1}>
                <CopyOutlined style={{ fontSize: 16 }} />
              </Box>
            </Tooltip>
          </CopyToClipboard>
          {showText && (
            <Box flex={1} mr={2}>
              <Text id={id} style={style}>
                <code style={style}>{text}</code>
              </Text>
            </Box>
          )}
        </Flex>
      )
    }
    return <div />
  }
}
